module.exports = __webpack_public_path__ + "img/9-1.862560f7.svg";